import { t } from '@lingui/macro';

export interface PreferencesModel extends PMZoneUnitsState {}

export interface PMZoneUnitsState {
  flowUnit: FlowUnitsAPIType;
  pressureUnit: PressureUnitsAPIType;
}

export const FlowUnitsAPI = {
  CubicMeterPerHour: 'CubicMeterPerHour',
  GallonsPerHour: 'GallonsPerHour',
  GallonsPerSecond: 'GallonsPerSecond',
  LitresPerHour: 'LitresPerHour',
  LitresPerSecond: 'LitresPerSecond',
  MegaLitresPerDay: 'MegaLitresPerDay',
  USGallonsPerMinute: 'USGallonsPerMinute',
} as const;
export type FlowUnitsAPIType = (typeof FlowUnitsAPI)[keyof typeof FlowUnitsAPI];

export const FlowUnitsOptionsFn = (): Record<FlowUnitsAPIType, string> => ({
  [FlowUnitsAPI.CubicMeterPerHour]: t({
    message: 'm3/h',
    id: '[FlowUnits.CubicMeterPerHour]',
    comment: 'Abbreviation from `Cubic Meter Per Hour` unit',
  }),
  [FlowUnitsAPI.GallonsPerHour]: t({
    message: 'g/h',
    id: '[FlowUnits.GallonsPerHour]',
    comment: 'Abbreviation from `Gallons Per Hour` unit',
  }),
  [FlowUnitsAPI.GallonsPerSecond]: t({
    message: 'g/s',
    id: '[FlowUnits.GallonsPerSecond]',
    comment: 'Abbreviation from `Gallons Per Second` unit',
  }),
  [FlowUnitsAPI.LitresPerHour]: t({
    message: 'l/h',
    id: '[FlowUnits.LitresPerHour]',
    comment: 'Abbreviation from `Litres Per Hour` unit',
  }),
  [FlowUnitsAPI.LitresPerSecond]: t({
    message: 'l/s',
    id: '[FlowUnits.LitresPerSecond]',
    comment: 'Abbreviation from `Litres Per Second` unit',
  }), // base
  [FlowUnitsAPI.MegaLitresPerDay]: t({
    message: 'Ml/d',
    id: '[FlowUnits.MegaLitresPerDay]',
    comment: 'Abbreviation from `Mega Litres Per Day` unit',
  }),
  [FlowUnitsAPI.USGallonsPerMinute]: t({
    message: 'US gpm',
    id: '[FlowUnits.USGallonsPerMinute]',
    comment: 'Abbreviation from `US Gallons Per Minute` unit',
  }),
});

//

export const PressureUnitsAPI = {
  MetreOfHead: 'MetreOfHead',
  Bar: 'Bar',
  Psi: 'Psi',
} as const;
export type PressureUnitsAPIType = (typeof PressureUnitsAPI)[keyof typeof PressureUnitsAPI];

export const PressureUnitsOptionsFn = (): Record<PressureUnitsAPIType, string> => ({
  [PressureUnitsAPI.MetreOfHead]: t({
    message: 'm',
    id: '[PressureUnits.MetreOfHead]',
    comment: 'Abbreviation from `Meter Of Head` unit',
  }), // base
  [PressureUnitsAPI.Bar]: t({
    message: 'Bar',
    id: '[PressureUnits.Bar]',
    comment: 'Abbreviation from `Bar` unit',
  }),
  [PressureUnitsAPI.Psi]: t({
    message: 'psi',
    id: '[PressureUnits.Psi]',
    comment: 'Abbreviation from `Psi` unit',
  }),
});
